import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Center.scss";
import Table from "../../../../Components/Table/Table";
import CustomToolbar from "../../../../Components/Table/components/CustomToolbar";
import ButtonField from "../../../../Components/Button/ButtonField";
import { Columns } from "../../../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import Dialog from "../../../../Components/Dialog/Dialog";
import ResponseDialog from "../../../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../../../Assets/Images/RefreshButton.svg";

// Center form
import CenterForm from "./CenterForm";
import { ICenter } from "./ICenter";
import { centreMasterRead } from "../../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMatserRead";
import { clearCentreMasterUpdate } from "../../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMasterUpdate";
import {
  centreMasterDelete,
  clearCentreMasterDelete,
} from "../../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMasterDelete";
import { clearCentreMasterCreate } from "../../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMasterCreate";

interface CenterProps { }

const Center: FunctionComponent<CenterProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<ICenter | {}>({
    status: true,
  });

  const dispatch = useAppDispatch();
  const { data: listCentersData, isLoading } = useAppSelector(
    (state) => state.CentreMasterReadSlice
  );
  const { data: addCenter } = useAppSelector(
    (state) => state.CentreMasterCreateSlice
  );
  const { data: editCenter } = useAppSelector(
    (state) => state.CentreMasterUpdateSlice
  );
  const { data: deleteCenters } = useAppSelector(
    (state) => state.CentreMasterDeleteSlice
  );

  const formRef = useRef<HTMLFormElement>(null);

  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "center_id",
    //   renderHeader: () => <b>Center ID</b>,
    //   flex: 1,
    //   type: "string",
    //   headerAlign: "left",
    // },
    {
      field: "center_name",
      renderHeader: () => <b>Center Name</b>,
      flex: 1,
      type: "string",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const loc = params.row.location;
        return loc ? `${loc.region}, ${loc.state}` : "-";
      },
    },

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "center",
      align: "center",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,
      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<ICenter>) => {
        return (
          <>
            <IconButtonField
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              onClick={() => {
                setDeleteData({
                  id: params.id,
                  name: params?.row?.center_name,
                });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Centers = Array.isArray(listCentersData?.data)
    ? listCentersData?.data.map((center, index) => ({
      ...center,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(centreMasterRead());
  }, [addCenter, editCenter, deleteCenters, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearCentreMasterCreate());
      dispatch(clearCentreMasterUpdate());
      dispatch(clearCentreMasterDelete());
    };
  }, [dispatch]);

  return (
    <>
      <Table rows={Centers ?? []} columns={columns} loading={isLoading}>
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({
                status: true,
              });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(centreMasterRead())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Center`}
        Dialog_Content={
          <CenterForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />

      <ResponseDialog response={addCenter} parentDialog={setDialogOpen} />
      <ResponseDialog response={editCenter} parentDialog={setDialogOpen} />

      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          if (deleteDialogData.id) {
            dispatch(centreMasterDelete({ id: deleteDialogData.id }));
          }
        }}
        response={deleteCenters}
      />
    </>
  );
};

export default Center;
